import { useLanguage } from '../providers/LanguageProvider';
import { getRTLConfig, getConditionalRTLClass } from '../config/rtl';

export const useRTL = () => {
  const { language, isRTL: isRTLMode } = useLanguage();
  const rtlConfig = getRTLConfig(language);

  const getRTLClass = (ltrClass = '', rtlClass = '') => {
    return getConditionalRTLClass(language, ltrClass, rtlClass);
  };

  const getRTLClasses = (baseClasses = '') => {
    return `${baseClasses} ${isRTLMode ? 'rtl' : 'ltr'}`.trim();
  };

  const getFlexDirection = (reverse = false) => {
    if (reverse) {
      return rtlConfig.flexDirectionReverse;
    }
    return rtlConfig.flexDirection;
  };

  const getMarginStart = (size = '') => {
    return `${rtlConfig.marginStart}${size}`;
  };

  const getMarginEnd = (size = '') => {
    return `${rtlConfig.marginEnd}${size}`;
  };

  const getPaddingStart = (size = '') => {
    return `${rtlConfig.paddingStart}${size}`;
  };

  const getPaddingEnd = (size = '') => {
    return `${rtlConfig.paddingEnd}${size}`;
  };

  const getTextAlign = () => {
    return rtlConfig.textAlign;
  };

  const getTextAlignOpposite = () => {
    return rtlConfig.textAlignOpposite;
  };

  return {
    language,
    isRTL: isRTLMode,
    rtlConfig,
    getRTLClass,
    getRTLClasses,
    getFlexDirection,
    getMarginStart,
    getMarginEnd,
    getPaddingStart,
    getPaddingEnd,
    getTextAlign,
    getTextAlignOpposite,
  };
};
